export default "__VITE_ASSET__Br1vH8TZ__"